const linkCost ={
    DEFAULT_URL : `${process.env.REACT_APP_SERVER_ADDRESS}/`
}
export default linkCost;